import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom, take } from 'rxjs';

import { FRONT_LOADING_ROUTES } from 'src/app/front-loading/routes';
import { isDeviceArrayFrontLoading, selectSettingDeviceType } from 'src/app/stores/settings';
import { TTW_ROUTES } from 'src/app/ttw/routes';

import { DEVICE_TYPES } from '../../interfaces/ISettings';
import { VIEW_TYPES } from '../../utils/constants';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(private router: Router, private store: Store) {}

  navigateToRootRoute(): void {
    this.store
      .select(selectSettingDeviceType)
      .pipe(take(1))
      .subscribe((deviceType) => {
        switch (deviceType) {
          case DEVICE_TYPES.NEXT_UP:
            this.router.navigate([`/${VIEW_TYPES.RETAIL}`]);
            break;
          case DEVICE_TYPES.ORDER_HQ_FRONT:
          case DEVICE_TYPES.ARRAY_FL:
            this.router.navigate([`/${VIEW_TYPES.FRONT_LOADING}`]);
            break;
          default:
            this.router.navigate([`/${VIEW_TYPES.REAR_LOADING}`]);
            break;
        }
      });
  }

  /**
   * Screen where the pickup flow starts and where it goes back to once it ends.
   * Array front-loading devices own their entry screen; the rest use the TTW one.
   */
  navigateToPickupEntry(): Promise<boolean> {
    return firstValueFrom(this.store.select(isDeviceArrayFrontLoading)).then(
      (isArrayFrontLoading) =>
        this.router.navigate([
          isArrayFrontLoading ? FRONT_LOADING_ROUTES.ENTER_SCAN_CODES : TTW_ROUTES.PICKUP_ORDER,
        ])
    );
  }
}
